{
  "min_players": 2,
  "max_players": 10,
  "reconnect_grace_seconds": 300,
  "heartbeat_interval_seconds": 10,
  "guess_seconds": 30,
  "scoring": {
    "correct_vote": 10,
    "wrong_vote": -5,
    "escaped_teammate": -5,
    "imposter_escape": 20,
    "imposter_perfect_escape": 25,
    "imposter_correct_guess": 10
  }
}
